import type { FragmentType } from "../../../../__generated__/gql";
import { PatternTable_ArticleFragmentDoc } from "../../../../__generated__/gql/graphql";
import KeywordTable from "./KeywordTable/KeywordTable";

export type SelectedSymbolPair = { name: string; value: string }[];

function KeywordReview({
  articles,
  setSelectedArticles,
}: {
  articles: FragmentType<typeof PatternTable_ArticleFragmentDoc>[];
  setSelectedArticles: React.Dispatch<React.SetStateAction<string[]>>;
}) {
  return (
    <KeywordTable
      articles={articles}
      setSelectedArticles={setSelectedArticles}
    />
  );
}

export default KeywordReview;
